import Env from '../base/env';
import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
gsap.registerPlugin(SplitText);

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      mouseenter: {
        trigger: 'hoverIn',
      },
    };
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.DOM.text = this.$('text');

    this.FX = {
      text: new SplitText(this.DOM.text, { type: 'chars' }),
    };

    this.animate();
    gsap.set(this.FX.text.chars, { autoAlpha: 1 });
  }

  animate() {
    this.animation = gsap.timeline({ paused: true });
    let timing =
      typeof this.DOM.view.dataset.type != 'undefined' &&
      this.DOM.view.dataset.type == 'nav'
        ? '+=.03'
        : '+=.08';
    for (let [i, char] of this.FX.text.chars.entries()) {
      this.animation.add(
        [
          gsap.set(this.FX.text.chars, {
            autoAlpha: 0,
          }),
          // gsap.set(this.FX.text.chars[i], {
          //   autoAlpha: 1,
          // }),
          // gsap.set(this.FX.text.chars[i + 1], {
          //   autoAlpha: 1,
          // }),
        ],
        timing
      );
      if (typeof this.FX.text.chars[i] != 'undefined') {
        this.animation.add(
          [
            gsap.set(this.FX.text.chars[i], {
              autoAlpha: 1,
            }),
          ],
          '>'
        );
      }
      if (typeof this.FX.text.chars[i + 1] != 'undefined') {
        this.animation.add(
          [
            gsap.set(this.FX.text.chars[i + 1], {
              autoAlpha: 1,
            }),
          ],
          '>'
        );
      }
      if (
        typeof this.DOM.view.dataset.type != 'undefined' &&
        this.DOM.view.dataset.type == 'nav'
      ) {
        if (typeof this.FX.text.chars[i + 2] != 'undefined') {
          this.animation.add(
            [
              gsap.set(this.FX.text.chars[i + 2], {
                autoAlpha: 1,
              }),
            ],
            '>'
          );
        }
        if (typeof this.FX.text.chars[i + 3] != 'undefined') {
          this.animation.add(
            [
              gsap.set(this.FX.text.chars[i + 3], {
                autoAlpha: 1,
              }),
            ],
            '>'
          );
        }
        if (typeof this.FX.text.chars[i + 4] != 'undefined') {
          this.animation.add(
            [
              gsap.set(this.FX.text.chars[i + 4], {
                autoAlpha: 1,
              }),
            ],
            '>'
          );
        }
      }
      console.log();
    }
    this.animation.call(() => {
      gsap.set(this.FX.text.chars, { autoAlpha: 0 });
    });
    this.animation.add(
      [
        gsap.set(this.FX.text.chars, {
          autoAlpha: 1,
          duration: 0.001,
          immediateRender: false,
          stagger: 0.03,
        }),
      ],
      '+=.1'
    );
  }

  hoverIn() {
    if (Env.mobileCSS == false) {
      this.animation.restart();
    }
  }
}
